import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <footer id="footer">
                <div className="container text-white">
                    <div className="row">
                        <div className="col-lg-12 text-right">
                            <p>
                                Copyright &copy; 2016-{new Date().getFullYear()} Novotec Solutions, LLC <br/>
                                All Rights Reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/js/App/Footer/Footer.js